// extracted by css-extract-rspack-plugin
export default {"form":"Ycj9SpcwHAkmBHNW","name":"RNGOnkbJUe54qR9_","username":"lI3mPlzpzLwJ43sD","submit":"FRewgRLdrQMuEo3b","submitButton":"VJQ0KdRmqX8_UYzO"};